import React, { createContext, useContext, useState, useEffect } from 'react';
import dashboardService from '../../services/dashboardService';
import { useAuth } from './AuthContext';

const ZoneContext = createContext(null);

export function ZoneProvider({ children }) {
  const { user } = useAuth(); 
  const [selectedZone, setSelectedZone] = useState('');
  const [selectedPlantId, setSelectedPlantId] = useState(null);
  const [locations, setLocations] = useState([]);
  const [lastSync, setLastSync] = useState(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!user) return; 

    dashboardService.getLocations().then((res) => {
      const plants = res?.data?.data?.plants ?? [];
      setLocations(plants);
      const firstPlant = plants[0];
      const firstArea = firstPlant?.areas?.[0]?.code;
      if (firstArea) setSelectedZone(firstArea);
      if (firstPlant?.id) setSelectedPlantId(firstPlant.id);
    }).catch(() => {
      setLocations([]);
    }).finally(() => {
      setIsReady(true);
    });
  }, [user]);

  const handleSetSelectedZone = (areaCode, plantId) => {
    setSelectedZone(areaCode);
    if (plantId !== undefined) setSelectedPlantId(plantId);
  };

  return (
    <ZoneContext.Provider value={{ 
      selectedZone, 
      setSelectedZone: handleSetSelectedZone, 
      selectedPlantId, 
      locations, 
      lastSync, 
      setLastSync,
      isReady 
    }}>
      {children}
    </ZoneContext.Provider>
  );
}

export function useZone() {
  const context = useContext(ZoneContext);
  if (!context) {
    throw new Error('useZone must be used within a ZoneProvider');
  }
  return context;
}
